{
  "feedback-emotion-page": {
    "text": {
      "title": "Phản hồi của bạn",
      "subtitle": "Hãy giúp chúng tôi cải thiện dịch vụ của mình",
      "dissatisfied": "Không hài lòng",
      "on": "vào",
      "neutral": "Bình thường",
      "satisfaction-question": "Bạn có hài lòng với dịch vụ của chúng tôi không?",
      "satisfied": "Hài lòng",
      "thanks": "Cảm ơn bạn đã ghé thăm",
      "tip": "Mẹo: Nhấp vào biểu tượng khuôn mặt để thể hiện mức độ hài lòng của bạn với dịch vụ của chúng tôi"
    }
  }
}
